import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    customLogo: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    }
}));
